import request from '@/utils/request'
import { getEffectiveCommunityId, normalizeCommunityId } from '@/api/community/communityApi'

function normalizeQueryParams(params = {}) {
  const nextParams = { ...params }
  if (Array.isArray(nextParams.communityIds)) {
    nextParams.communityIds = nextParams.communityIds.filter(Boolean).join(',')
  }
  if (Object.prototype.hasOwnProperty.call(nextParams, 'communityId')) {
    nextParams.communityId = normalizeCommunityId(nextParams.communityId)
  }
  return nextParams
}

function omitCommunityScope(data = {}) {
  const { communityId, communityIds, ...rest } = data
  return rest
}

// 获取投诉类型列表
export function listComplaintType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/complaintType.listComplaintType',
      method: 'get',
      params: normalizeQueryParams(params)
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除投诉类型
export function deleteComplaintType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/complaintType.deleteComplaintType',
      method: 'post',
      data: omitCommunityScope(data)
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加投诉类型
export function addComplaintType(data) {
  return new Promise((resolve, reject) => {
    const communityId = getEffectiveCommunityId(data.communityId)
    request({
      url: '/complaintType.saveComplaintType',
      method: 'post',
      data: {
        ...data,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新投诉类型
export function updateComplaintType(data) {
  return new Promise((resolve, reject) => {
    const communityId = getEffectiveCommunityId(data.communityId)
    request({
      url: '/complaintType.updateComplaintType',
      method: 'post',
      data: {
        ...data,
        communityId
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取单个投诉类型详情
export function getComplaintTypeDetail(typeCd, communityId) {
  return new Promise((resolve, reject) => {
    const params = { typeCd }
    const scopeCommunityId = normalizeCommunityId(communityId)
    if (scopeCommunityId) {
      params.communityId = scopeCommunityId
    }
    request({
      url: '/complaintType.getComplaintType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
